export default "/images/slickslide-3.jpg?d5fb858b530ee89f9b6207a728eb3125";